<template>
    <div>
        <modal
            class="is-narrow"
            v-bind:title="__('Are you sure?')"
            v-bind:is-open="true"
            v-on:close-modal="closeModal"
        >
            <template v-slot:body>
                <p
                    class="has-text-center"
                    v-html="
                        __(
                            'Are you sure you want to delete this newsletter?<br />This action cannot be undone.'
                        )
                    "
                ></p>
            </template>
            <template v-slot:footer>
                <div class="has-padding-t10">
                    <div class="columns">
                        <div class="column">
                            <btn
                                class="is-block"
                                type="cancel"
                                v-html="__('Cancel')"
                                v-on:click="closeModal"
                            >
                            </btn>
                        </div>
                        <div class="column">
                            <btn
                                class="is-block"
                                type="error"
                                v-html="__('Delete')"
                                v-on:click="deleteNewsletter"
                            >
                            </btn>
                        </div>
                    </div>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
import { Btn, Modal } from '@teamfurther/cinderblock';

export default {
    components: {
        Btn,
        Modal
    },
    methods: {
        closeModal: function() {
            this.$emit('close');
        },
        deleteNewsletter: function() {
            this.$emit('delete');
        }
    }
};
</script>
